<script lang="ts">
  import Seo from '$components/seo.svelte';
  import { t } from '$lib/i18n';
  import WishlistPage from '$pages/wishlist/wishlist-page.svelte';
</script>

<Seo title="{$t('wishlist.title')} | Hey Harper" />
<WishlistPage />
